module.exports = __webpack_public_path__ + "static/img/waiting_approve_wallet.ae52ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/waiting_approve_wallet.png
// module id = DCrw
// module chunks = 150